import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "./useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import ExcelPopup from "./ExcelPopup";
import UploadContract from "./UploadContract";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import LinkPayment from "./LinkPayment";
import ViewStationsModal from "../audioadminmanagment/ViewStationsModal";
import VerifyReconciledPayment from "./VerifyReconciledPayment";

const FailedCampaigns = (props) => {
  const [audioStateArr] = useState(["New", "Link Payment", "Delete"]);

  const [campaigns, handleCampaignList] = useState([]);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [packagetype, handlePackagetype] = useState(undefined);
  const [updatePaymentId, handleupdatePaymentId] = useState(false);
  const [paymentId, handlePaymentId] = useState(undefined);
  const [campaignId, handleCampaignId] = useState("");
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);


  //vjvjj
  const [campaignstatustype, handleCampaignstatustype] = useState(undefined);

  const [razorpay, handleRazorpay] = useState(undefined);
  const searchRazorpay = useRef(undefined);

  const [station, handleStation] = useState(undefined);
  const [email, handleEmail] = useState(undefined);
  const [searchName, handleSearchName] = useState(undefined);
  //vj
  // const [searchStation, handleSearchStation] = useState(undefined);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const [showUploadContract, setShowHideUploadContract] = useState(false);
  const campaignName = useRef(undefined);
  const userEmail = useRef(undefined);
  const searchStation = useRef(station);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const [currentCampaign, handleCurrentCampaign] = useState(undefined);
  const [updateObj, handleUpdateObj] = useState(undefined);
  const [searchCampaignId, handleSearchCampaignId] = useState(undefined);
  const { isVerifyReconciledPaymentModalShowing, verifyReconciledPaymentModalToggle, campaignForVerification, campaignForVerificationPaymentDate, campaignForVerificationPaymentAmount, campaignForVerificationTransactionProof } = useModel();
  const [deleteCampaignId, handleDeleteCampaignId] = useState(undefined);
  const [deleteComment, handleDeleteComment] = useState('');

  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  }, []);

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    if (!reset) {
      
      if (adminInfo.role !== "stationAdmin") {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: searchStation.current.value,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
          campaigntype: "Draft",
          cluster: adminInfo.cluster,
        };
      } else {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: adminInfo.station,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
          campaigntype: "Draft",
        };
      }
    }
    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.getAllCampaign, {
        params: paramsConstrct,
      });
      let result = data.data.data.data;
      if (result) {
        result = result.map((campaign) => {
          return calculateAmountAndTax(campaign);
        });
        handleCampaignList(result);
        handleSearchName(name);
        handleRazorpay(razorpay);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };

  const removePaymentId = () => {
    handleupdatePaymentId(!updatePaymentId);
    handlePaymentId(undefined);
  };

  //Set audio status
  const setAudioStatus = async (event, campaign) => {
    let { value } = event.target;
    
    if (value === "New") {
      alert(`Campaign Can't be moved to New state`);
      return;
    }
    if (value == "Link Payment") {
      handleupdatePaymentId(true);
      console.log("asdsadsadsadsadsadasd", updatePaymentId);
      handleCampaignId(campaign._id);
      return;
    }
    if (value === "Delete") {
      handleDeleteCampaignId(campaign._id);
      return;
    }
    getCampaignlist(skip, undefined, undefined, "Pending", false);
  };

  const showHideExcelPopup = () => {
    setShowHideExcelPopup(!showExcelPopup);
  };

  const callSearch = () => {
    getCampaignlist(0, undefined, searchCampaignId, "Pending", false);
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  const toggleRecordOfflineModal = () => {
    verifyReconciledPaymentModalToggle();
  };

  const closeRecordOfflineModal = () => {
    verifyReconciledPaymentModalToggle();
  };

  const deleteFailedCampaign = (id) => {
    handleDeleteCampaignId(id);
  }

  const submitDeleteCampaign = async () => {
    try {
      const deleteResponse = await Axios.post(endPoints.deleteFailedCampaign, {
        id: deleteCampaignId,
        comment: deleteComment
      });
      if(deleteResponse && deleteResponse.data){
        handleDeleteComment('');
        handleDeleteCampaignId(undefined);
        getCampaignlist(skip, undefined, undefined, "Pending", false);
      }
    } catch (error) {
      console.log(error);
    }
    
  }
  
  //Return the table for campaign
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Campaign Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                 Failed Campaign List{" "}
                </span>{" "}
              </div>
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div
                        className={
                          !searchCampaignId && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        {/*<input type="text" placeholder="Campaignname search" onChange={getSearch}/>*/}{" "}
                        <input
                          type="text"
                          placeholder="Enter campaign Id"
                          onChange={ (e)=> { handleSearchCampaignId(e.target.value)}}
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="startDate">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Start Date"
                          maxDate={endDate}
                          isClearable
                        />
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="endDate">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          minDate={startDate}
                          placeholderText=" End date"
                          isClearable
                        />
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon"
                          onChange={(event) =>
                            handlePackagetype(event.target.value)
                          }
                        >
                          <option value=""> Choose Package Type </option>{" "}
                          <option value="Frequency Based">
                            {" "}
                            Frequency Based{" "}
                          </option>{" "}
                          <option value="Day Based"> Day Based </option>{" "}
                          <option value="Rotation Based"> Rotation Based </option>{" "}
                          <option value="Month Based">
                            {" "}
                            Payment Completed{" "}
                          </option>{" "}
                          <option value="Production Sale">
                            {" "}
                            Production Sale{" "}
                          </option>{" "}
                        </select>{" "}
                      </div>{" "}
                    </td>
                    {localStorage.getItem("adminRole") &&
                      localStorage.getItem("adminRole") === "campaignAdmin" && (
                        <td>
                          <div className="drop">
                            <select
                              className="packageType drop-down-icon"
                              onChange={(event) =>
                                handleCampaignstatustype(event.target.value)
                              }
                            >
                              <option value=""> Campaign status </option>{" "}
                              <option value="Audio Approved">
                                Audio Approved{" "}
                              </option>{" "}
                              <option value="RO Approved"> RO Approved </option>{" "}
                              <option value="New Campaign">
                                New Campaign{" "}
                              </option>{" "}
                              <option value="Payment Pending">
                                Payment Pending{" "}
                              </option>{" "}
                              <option value="Payment Completed">
                                {" "}
                                Payment Completed{" "}
                              </option>{" "}
                            </select>{" "}
                          </div>{" "}
                        </td>
                      )}
                    {localStorage.getItem("adminRole") &&
                      localStorage.getItem("adminRole") === "trafficAdmin" && (
                        <td>
                          <div className="drop">
                            <select
                              className="packageType drop-down-icon"
                              onChange={(event) =>
                                handleRostatustype(event.target.value)
                              }
                            >
                              <option value=""> Ro status </option>{" "}
                              <option value="Day Based"> RO Approved </option>{" "}
                              <option value="Month Based"> RO Booked </option>{" "}
                            </select>{" "}
                          </div>{" "}
                        </td>
                      )}
                    <td>
                      <div className="print_btn">
                        {" "}
                        {/***  <button type="button" onClick={clearSearch}>Clear</button>*/}{" "}
                        <button type="reset" onClick={clearSearch}>
                          Clear{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>
                    <td> </td>{" "}
                  </tr>
                  <tr>
                    <td>
                      <div
                        className={
                          !searchName && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        {/*<input type="text" placeholder="Campaignname search" onChange={getSearch}/>*/}{" "}
                        <input
                          type="text"
                          ref={campaignName}
                          placeholder="Enter campaign name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div
                        className={
                          !email && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={userEmail}
                          placeholder="Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    {adminInfo.role !== "stationAdmin" && 
                    <td>
                      <div
                        className={
                          !station && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={searchStation}
                          placeholder="Station Name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>}
                    <td>
                      <div
                        className={
                          !razorpay && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={searchRazorpay}
                          placeholder="Razorpay ID"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>{" "}
                  </tr>{" "}
                </tbody>{" "}
              </table>{" "}
            </form>{" "}
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th> Campaign Name </th>
                    <th> Created Date </th>{" "}
                    <th> Start Date </th>
                    <th> Station </th>{" "}
                    <th> Package Type </th>
                    <th> Payment Status </th>{" "}
                    <th> Status </th> 
                    <th> CampaignId </th>
                    <th> User Email </th>
                    <th> Price </th>{" "}
                    <th> payId </th>
                    <th> payId_1 </th>
                    <th> Sales User Id </th>
                    {/* <th> Actions</th>{" "} */}
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td> {c.name} </td>{" "}
                      <td> {moment(c.createdAt).format("DD/MM/YYYY")} </td>{" "}
                      <td> {moment(c.startDate).format("DD/MM/YYYY")} </td>{" "}
                      <td> {c.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  handleshowstationlist(true);
                                  handleCurrentStations(c.station.split(","));
                                }}
                              >
                                Multiple ({c.station.split(",").length})
                              </a>
                            ) : (
                              c.station
                            )} </td>{" "}
                      <td> {c.type} </td> <td>{"Payment Pending"}</td>
                      <td>
                        {" "}
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") === "admin" || localStorage.getItem("adminRole") === "campaignAdmin" || localStorage.getItem("adminRole") === "financeAdmin")  && (
                            <select
                              onChange={(event) => setAudioStatus(event, c)}
                              value={c.status === "Pending" ? "New" : c.status}
                              className={
                                c.status == "Pending"
                                  ? "status_select new"
                                  : c.status === "RO Approved"
                                  ? "status_select audio_approved"
                                  : "status_select ro_approved"
                              }
                              disabled={c.status === "RO Approved"}
                            >
                              {audioStateArr.map((audioState, index) => (
                                (audioState != "Delete" || (audioState == "Delete" && (moment().diff(moment(c.createdAt), 'days') > 90))) && (
                                  <option key={index}> {audioState} </option>
                                )
                              ))}{" "}
                            </select>
                          )}
                      </td>{" "}
                      <td> {c._id} </td> <td> {c.userEmail} </td>{" "}
                      <td> {c.totalCost} </td>{" "}
                      {/* <td className={c.status === "Pending" ? "tbl_bg_new" : c.status === 'Audio Approved' ? "tbl_bg_audio_approved" : c.status === 'RO Approved' ? 'tbl_bg_audio_approved' : c.status === 'RO Booked' ? 'tbl_bg_green' : ''}> */}
                      <td> {c.payId} </td> <td> {c.payId_1} </td>
                      <td> {c.sallerId} </td>{" "}
                      {/* <td>
                        { localStorage.getItem("adminRole") === "admin" && (moment().diff(moment(c.createdAt), 'days') > 90) && (
                            <button style={{color: 'black', background: 'silver'}} onClick={ (e) => deleteFailedCampaign(c._id) }> Delete </button> 
                        ) }
                      </td> */}
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}

          { deleteCampaignId && (
            <div className="modal-overlay">
              <div
                className="modal-wrapper thankyou-popup"
                aria-modal
                aria-hidden
                tabIndex={-1}
                role="dialog"
              >
                <div className="modal approval">
                  <div className="modal-head-cross rate-modal">
                    <button
                      type="button"
                      className="modal-close-button"
                      onClick={ (e) => { handleDeleteCampaignId(undefined) }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="editNonFct-header modal-header">
                      <h4 className="rqst-head fct-head modal-title">
                        Comment
                      </h4>

                      <textarea placeholder="Enter comment" rows="4" style={{ padding: "5px", margin: "5px 0px", width: "100%", border: "1px solid #94aeca", borderRadius: "5px" }} onChange={ (e)=> { handleDeleteComment(e.target.value) }}></textarea>

                      <button style={{float: "right", padding: "5px", color: "white"}} onClick={submitDeleteCampaign}>Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>{" "}
      </div>{" "}
      {/* {campaigns.length ===0 && (!searchName && !searchId)?
                      <NoData /> : null} */}{" "}
      {showExcelPopup && <ExcelPopup hideExcelPopup={showHideExcelPopup} />}
      {updatePaymentId && (
        <LinkPayment
          campaignId={campaignId}
          closeAction={removePaymentId}
          okButtonText="Proceed to Payment"
          okAction={handlePaymentId}
          cancelButtonShow={true}
          cancelButtonText="Cancel"
        />
      )}
      {showstationlist && (
                <ViewStationsModal
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
      <VerifyReconciledPayment 
        isShown={isVerifyReconciledPaymentModalShowing}
        hide={toggleRecordOfflineModal}
        close={closeRecordOfflineModal}
        campId={campaignForVerification}
        pDate={campaignForVerificationPaymentDate}
        pAmount={campaignForVerificationPaymentAmount}
        transactionProof={campaignForVerificationTransactionProof}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(FailedCampaigns);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/failedcampaigns.js